import {GetDiscountsApiResponse} from "../types";

type UpdateCurrentPage = {
  type: "update-current-page";
  payload: number;
};
type UpdatePerPage = {
  type: "update-per-page";
  payload: number;
};

export type GetDiscountCodesActions = UpdateCurrentPage | UpdatePerPage;

export type GetDiscountCodesState = {
  currentPage: number;
  per_page: number;
  discountCodes: GetDiscountsApiResponse["data"]["discounts"];
  discountCodesMeta?: GetDiscountsApiResponse["meta"];
  isPreviousData: boolean;
  isLoading: boolean;
  isFetching: boolean;
};

export const initialGetDiscountCodesState: GetDiscountCodesState = {
  currentPage: 1,
  per_page: 10,
  discountCodes: [],
  discountCodesMeta: undefined,
  isPreviousData: false,
  isLoading: false,
  isFetching: false,
};

export const getDiscountCodesReducer = (
  state: GetDiscountCodesState = initialGetDiscountCodesState,
  action: GetDiscountCodesActions
) => {
  if (action.type === "update-current-page") {
    return {...state, currentPage: action.payload};
  }
  if (action.type === "update-per-page") {
    return {...state, per_page: action.payload};
  }
  //   if (action.type === "reset-state") {
  //     return {...initialCreateProductFormState};
  //   }

  return state;
};
